import { Row } from "react-bootstrap";
import styled from "styled-components";

/**
 * a row of partners images
 */
const PartnerRow = styled(Row)``;

export { PartnerRow };
